import * as React from 'react';
import { useEffect, useState } from 'react';
import Modal from "../../../component/Global/Modal";
import ReusableDiv from 'src/support/ReusableDiv';
import { useAccountStore } from "../../../hooks/admin/account";
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';
import { useUserStore } from 'src/hooks/admin/user';
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";


const UnsponsorUserAcct = (props) => {
    const [status, SetStatus] = useState(false);
    const [{ }, { }, { update_unsponsor_acct_by_user }] = useAccountStore();
    const [{ }, { }, { update_unsponsor_user_acct }] = useUserStore();
    const { list, userId } = props.data;
    const [refreshGrid, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
    const [userListErrAlert, setUserListErrAlert] = useReduxState("", "setUserListErrAlert");
    const [errAlertType, setErrAlertType] = useReduxState("", "setErrAlertType");
    const [errMessage, setErrMessage] = useState('');
    const [__check] = useAxiosIndicatorCheck();


    useEffect(() => {
        SetStatus(true)
    }, []);

    const queryPrams = System.getParams()
    const onHide = () => {
        SetStatus(false)
    };

    const onSubmit = async () => {
        if (props.data.base === 'userDetails') {
            let params = {
                userId: props.data.userId,
                accountDetails: props.data.list.map((acc) => {
                    return {
                        accountNumber: acc.AccountNumber,
                        speedboat: acc.Speedboat,
                        salesOrg: acc.SalesOrg,
                    }
                })
            }
            __set("UNSPONSOR_API_CALL");
            await update_unsponsor_user_acct(params)
                .then((data) => {
                    setErrMessage('');
                    setUserListErrAlert('User has been successfully <b>Unsponsored</b> from account(s).', 'success', 'userAcct');
                    setErrAlertType('success');
                    setRefreshGrid(true);
                    onHide();
                    __remove("UNSPONSOR_API_CALL");
                }).catch((err) => {
                    setErrMessage(err.response.data.message || 'Something went wrong');
                    __remove("UNSPONSOR_API_CALL");
                })
        } else {
            let params = {
                ...queryPrams,
                userId: list.map(user => user.UserId),
            }
            __set("UNSPONSOR_API_CALL");
            await update_unsponsor_acct_by_user(params)
                .then((data) => {
                    setErrMessage('');
                    setUserListErrAlert('User has been successfully <b>Unsponsored</b> from account(s).', 'success', 'userAcct');
                    setErrAlertType('success');
                    setRefreshGrid(true);
                    onHide();
                    __remove("UNSPONSOR_API_CALL");
                }).catch((err) => {
                    setErrMessage(err.response.data.message || 'Something went wrong');
                    __remove("UNSPONSOR_API_CALL");
                })
        }
    };

    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className="avnet-modal modal-730 unsponsor-modal">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => { onHide() }}>×</button>
                        {ReusableDiv.PopupTitle("Unsponsor from Account(s)")}
                        <div className="modal-body">
                            <p className="text-center"> <strong> {props.data.base === 'userDetails' ? 'You are about to unsponsor this User from the Account(s) listed below.' : 'You are about to unsponsor this User(s) listed below.'} </strong></p>

                            <table className="bs5 table table-bordered mt-4 mb-4">
                                <thead>
                                    {props.data.base === 'userDetails' ?
                                        <tr>
                                            <th>ACCOUNT NUMBER  </th>
                                            <th>ACCOUNT NAME </th>
                                            <th>SPEEDBOAT</th>
                                            <th>SALES ORG</th>
                                        </tr> :
                                        <tr>
                                            <th>EMAIL  </th>
                                            <th>FIRST NAME </th>
                                            <th>LAST NAME</th>
                                        </tr>}
                                </thead>
                                <tbody>
                                    {props.data.base === 'userDetails' ?
                                        list.map((v, i) => (

                                            <tr key={i}>
                                                <td>{v.AccountNumber} </td>
                                                <td>{v.AccountName} </td>
                                                <td>{v.Speedboat} </td>
                                                <td>{v.SalesOrg} </td>
                                            </tr>
                                        )) :
                                        list.map((v, i) => (
                                            <tr key={i}>
                                                <td>{v.Email} </td>
                                                <td>{v.FirstName} </td>
                                                <td>{v.LastName} </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                            <p className="text-center">
                                This action can not be reversed. Click “OK” to complete.
                                <br /><span style={{ color: 'red' }}>  Note: you will not be able to reverse this action. </span>
                            </p>
                            {errMessage && <AlertContentWithFlag message={errMessage} type={'danger'} isDisplay={false} isDisplayIcon={true} />}
                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary minw140"
                                onClick={() => { onHide() }}>Cancel</button>
                            <button
                                type="button"
                                className="bs5 btn btn-primary minw140"
                                disabled={__check(["UNSPONSOR_API_CALL"]).status}
                                onClick={() => {
                                    __check(["UNSPONSOR_API_CALL"]).status
                                        ? e.preventDefault()
                                        : onSubmit();
                                }}
                            >
                                {(__check("UNSPONSOR_API_CALL").status) ? (
                                    <i className="fa fa-spinner fa-spin" />
                                ) : (
                                    "OK"
                                )}{" "}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default UnsponsorUserAcct;